export const AiRecommend = {
  "title": "Recommend",
  "IsNDA": "The current document is identified as a non-disclosure agreement.",
  "SelectType": "Please help us to be better by selecting correct type.",
  "NotNDA": "No, I don't think so.",
  "YouCanTry": "You can try:",
  "ToSign": "Add a signature to a PDF file by typing, drawing, <span class='font-purple'>or inserting a signature file.</span>",
  "SignItNow": "Sign it now",
  "ToRedaction": "Quickly scan and remove confidential information in your documents. <span class='font-purple'>or Click \"Auto Redaction\" in \"Protect\".</span>",
  "ScanRedact": "Scan & Redact",
  "NotShow": "Don't show again",
  "panel": {
    "title": "Auto Redaction"
  }
}